import { createSlice } from '@reduxjs/toolkit';
import API from '../../services/api';
import {USERS_API_URL} from '../../config/service';
import { showError, showSuccess } from '../messages/messagesSlice';
import { resetUsersSurveyData } from '../manageuserdetails/ManageUsersSurveyDataSlice';

export const makeAdminSlice = createSlice({
  name: 'makeadmin',
  initialState: {
    value: '',
  },
  reducers: {
    makeAdminStatus: (state, action) => {
      state.value = action.payload;
    }
  },
});

export const { makeAdminStatus } = makeAdminSlice.actions;

export const makeAdminUser = username => async (dispatch) => {
    try {
    const response = await API.put(`${USERS_API_URL}/v1/users/makeadmin`, {
      username: username,
    });
    if (response.data) {
      dispatch(makeAdminStatus(true));
    }
    dispatch(showSuccess({ "message": "User has successfully been made an admin." }));
    return true;
  } catch (error) {
    dispatch(showError({ "message": `User could not be made an admin. ${error.message}` }));
    return false;
  }
};

export const selectMakeAdminStatusSelector = state => state.makeadmin.value;

export default makeAdminSlice.reducer;
